import { render, staticRenderFns } from "./accountApply.vue?vue&type=template&id=80fdb162&"
import script from "./accountApply.vue?vue&type=script&lang=js&"
export * from "./accountApply.vue?vue&type=script&lang=js&"
import style0 from "./accountApply.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports